module.exports = __webpack_public_path__ + "static/media/training-center.916e22a0.jpg";